import { Box, MenuItem as BaseMenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuItem = styled(BaseMenuItem)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1, 1.5)};
  min-width: 140px;
  &.Mui-disabled {
    opacity: 0.5;
  }
`;

export const ItemTitle = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const SubmenuPaper = styled(Box)`
  padding: ${(p) => p.theme.spacing(0.5, 0)};
`;
